<template>
  <el-drawer
    title="学习记录"
    :visible.sync="showPop"
    :direction="direction"
    :custom-class="classNames + '_wrap'"
    @close="handleClose"
  >
    <div :class="classNames" v-loading="isLoading === 'noFullScreen'">
      <p v-if="share_node === 1" style="padding-left: 12px;">{{ totalTimes[1] }}</p>
      <el-scrollbar style="flex: 1" ref="scrollbar" class="collapse">
        <div style="white-space: pre-wrap;height: auto;font-size: 0;" v-html="ruleHtmlText"></div>
        <div :class="classNames + '_content'" v-if="learnRecords.length">
          <div
            :class="classNames + '_chapter_none'"
            v-if="learnRecords.length ==1"
          >
             <div
                v-for="(item, index) in learnRecords[0].shows"
                :key="item.id"
                :class="classNames + '_chapter_list'"
              >
               
                  <div :class="classNames + '_chapter_list_title'"> {{index+1}}.{{ item.title }} 
                      <div>学习时长: {{ item.status }}</div>
                  </div>
              </div>
          </div>
          <div :class="classNames + '_chapter'" v-if="learnRecords.length > 1">
            <el-collapse v-model="activeNames" @change="handleChange">
              <div
                v-for="(item, index) in learnRecords"
                :key="item.id"
                class="chapter_list"
              >
                <el-collapse-item
                  :title="item.name ? item.name : '暂无标题'"
                  :name="index"
                >
                  <div
                    v-for="(values, keys) in item.shows"
                    :key="values.id"
                  >
                   <div class="title">{{index+1}}.{{keys+1}} {{ values.title }}</div> 
                   学习时长: {{ values.status }}
                  </div>
                </el-collapse-item>
              </div>
            </el-collapse>
          </div>
        </div>
        <div :class="classNames + '_content'"  v-if="learnRecords_free.length">
          <div
            :class="classNames + '_chapter_none'"
          >
             <div
                v-for="(item) in learnRecords_free"
                :key="item.id"
                :class="classNames + '_chapter_list'"
              >

                  <div v-if="share_node === 1" :class="classNames + '_chapter_list_title'"> 
                      {{item.is_free_product==0?'主课':'赠课'}}:{{ item.title }}
                      <span class="user_see_total_time">{{ (item.study_total_time-0) ? `(${getStudyOrproductTime(item.study_total_time, item.product_total_time)})` : '' }}</span>
                      <!-- 图文课 -->
                      <div v-if="item.product_type==2">学习时长: {{ item.study_status == 1 ? '已观看' : '未观看' }}</div>
                      <!-- 音视频课 -->
                      <div v-else>学习时长: {{ formatSeconds(item.study_total_time) }}</div>
                  </div>
                   <div v-else :class="classNames + '_chapter_list_title'">
                      {{ item.title }}
                      <span class="user_see_total_time">{{ (item.study_total_time-0) ? `(${getStudyOrproductTime(item.study_total_time, item.product_total_time)})` : '' }}</span>
                      <div v-if="item.type !== 'title'">
                        <!-- 图文课 -->
                        <div v-if="item.product_type==2">学习时长: {{ item.study_status == 1 ? '已观看' : '未观看' }}</div>
                        <!-- 音视频课 -->
                        <div v-else>学习时长: {{ formatSeconds(item.study_total_time) }}</div>
                      </div>
                      <!-- <div v-if="item.type !== 'title'">学习时长: {{ formatSeconds(item.study_total_time) }}</div> -->
                  </div>
              </div>
          </div>
        </div>
        <div v-if="!learnRecords.length&&!learnRecords_free.length" :class="classNames + '_content_none'">
          <img src="@/assets/image/empty.png" alt="" />
        </div>
      </el-scrollbar>
    </div>
  </el-drawer>
</template>
<script>
import { mapState, mapActions } from "vuex";
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { refundRuleObj } from './data.js'
dayjs.extend(duration)
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: "",
    },
    channel_type:{
      type: [Number, String],
      default: ''
    }
  },
  created() {
    this.$watch(
      () => this.value,
      (news) => {
        this.showPop = news
        if (news) {
          this.loading = true;
          this.getLearnRecords();
        }
      }
    );
  },
  data() {
    return {
      direction: "rtl",
      classNames: "drawer",
      loading: false,
      learnRecords: [],
      activeNames: [0],
	  show_counts: 0,
	  study_counts: 0,
    learnRecords_free:[],
    share_node: 0,
      totalTimes: {},
      showPop: false // 展示抽屉
    };
  },
  computed: {
    ...mapState(["isLoading"]),
    ruleHtmlText(){ // 退款规则
      if(this.staticPath in refundRuleObj){
        return refundRuleObj[this.staticPath].text
      }else{
        return refundRuleObj['other'].text
      }
    }
  },
  methods: {
    ...mapActions("withdrawal", ["studyRecord"]),
    handleClose() {
      this.$emit("input", false);
      this.learnRecords = []
      this.learnRecords_free = []
     this.show_counts=0
	  this.study_counts=0
    },
    async getLearnRecords() {
      const totalTimes = {}
      let res = await this.studyRecord({ id: this.id,channel_type:this.channel_type });
      this.share_node = res.share_node || 1
      const valueList = [
          {
            value: 'douyin',
            label: '抖音'
          },
          {
            value: 'weixin',
            label: '微信'
          },
          {
            value: 'kuaishou',
            label: '快手'
          }
      ]
      let shareNodeObj = {
        2: ['douyin', 'weixin'],
        3: ['douyin', 'kuaishou'],
        4: ['douyin', 'kuaishou', 'weixin']
      }
      if(this.share_node === 1) {
        if(res.list){
          this.learnRecords = res.list;
          this.show_counts = res.show_counts;
          this.study_counts = res.study_counts;
          // totalTimes[1] = this.getStudyOrproductTime(res?.study_total_time, res?.product_total_time)
          totalTimes[1] = this.getTotalStudyTime(res?.product_type, res?.study_status, res?.study_total_time, res?.product_total_time)
        }else{
          this.learnRecords_free = res
          // totalTimes[1] = this.getStudyOrproductTime(res[0]?.study_total_time, res[0]?.product_total_time)
          // totalTimes[1] = this.getTotalStudyTime(res[0]?.product_type, res[0]?.study_status, res[0]?.study_total_time, res[0]?.product_total_time)
          totalTimes[1] = ''
        }
      } else {
        const filterShareNode = shareNodeObj[res.share_node]
        this.learnRecords_free = filterShareNode.reduce((pre, item) => {
          const obj = valueList.find(ele => ele.value === item)
          totalTimes[obj.value] = this.getStudyOrproductTime(res[item][0]?.study_total_time, res[item][0]?.product_total_time)
          if(obj && res[item]) {
            pre.push({type: 'title', title: obj.label, isTitle: true, typeWords: obj.value }, ...res[item])
          }
          return pre
        }, [])
      }
      
      this.totalTimes = totalTimes
      console.log(res, " this.learnRecords---");
      console.log("hhh-learnRecords_free", this.learnRecords_free);
      this.loading = false;
      this.$nextTick(() => {
        this.$refs.scrollbar.wrap.scrollTop = 0;
        // console.log(, '..this.$refs.scrollbar')
      });
    },
    handleChange(val) {
      // this.chapterListCurrent = val
      console.log(val, "handleChange");
    },
    getStudyOrproductTime(va1,va2) {
      return va1 > 0 ?  `用户观看总时长 ${this.secondsToMinute(va1)}/课程总时长 ${this.secondsToMinute(va2)}` : ''
    },
    secondsToMinute(value) {
      // console.log(value, "secondsToMinute",dayjs.duration(value, 'seconds').format('YYYY-MM-DD HH时mm分ss秒') );
      
          const totalSeconds = value;
				  const hours = Math.floor(totalSeconds / 3600);
				  const minutes = Math.floor((totalSeconds % 3600) / 60);
				  const seconds = totalSeconds % 60;
          return `${hours}时${minutes}分${seconds}秒`;
      // return dayjs.duration(value, 'seconds').format('HH时mm分ss秒') 
    },
    //  秒数转化为时分秒
    formatSeconds(secondsVal=0){ // 61 => 00:01:01
      return dayjs.duration(secondsVal,'seconds').format('HH:mm:ss')
    },
    getTotalStudyTime(type=1, status=2, study=0, total=0){
      // product_type 1=音视频课 2=图文课, study_status 1=已学习 2=未学习
      if(type==2){
        return status==1 ? '用户观看总时长: 已观看' : '用户观看总时长: 未观看'
      }else{
        return this.getStudyOrproductTime(study, total)
      }
    }
  },
};
</script>
<style lang="less">
@classNames: drawer;
.@{classNames}_wrap {
  .el-drawer__body {
    height: 0;
  }
  .el-drawer__header {
    height: 48px;
    span {
      font-size: 20px;
      font-weight: 600;
      color: #37383c;
    }
  }
}
</style>
<style lang="less">
    @classNames: drawer;
    .@{classNames} {
        display: flex;
        flex-direction: column;
        height: 100%;
        .@{classNames}_content {
            padding: 20px;
            border-top: 1px solid rgb(243, 244, 249);
            .@{classNames}_chapter{
                width: 100%;
                .el-collapse {
                    box-sizing: border-box;
                    border: none;
                    background-color: transparent;
                        .chapter_list {
                            width: 100%;
                            color: #000;
                        }
                        .el-collapse-item__header {
                            background-color: #fff;
                            color: rgba(0, 0, 0, 0.5);
                            border: none;
                            box-sizing: border-box;
                            // background-color: transparent;
                        }
                        .el-collapse-item__header.is-active {
                            color: rgba(0, 0, 0, 1);
                        }
                    .el-collapse-item__wrap {
                        background-color: transparent;
                        border: none;
                        .el-collapse-item__content {
                            width: 100%;
                        padding: 0;
                        color: rgba(0, 0, 0, .7);
                        line-height: 30px;
                        div {
                            width: 100%;
                            color: rgba(0, 0, 0, .7);
                           padding: 0 20px;
                           box-sizing: border-box;
                          display: flex;
                          .title{
                                display: block;
                            width: 60%;
                             overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                          }
                        }
                    }
                }
            }
            }
             .@{classNames}_chapter_none{
                 width: 100%;
                 .@{classNames}_chapter_list{
                     color: #000;
                     .@{classNames}_chapter_list_title{
                         width: 100%;
                         line-height: 20px;
                         margin-bottom: 20px;
                        //  overflow: hidden;
                        // white-space: nowrap;
                        // text-overflow: ellipsis;
                        .user_see_total_time{
                          font-size: 10px;
                          color: rgba(0, 0, 0, 0.6);
                        }
                         div{
                             margin-top: 10px;
                             font-size: 12px;
                             color: rgba(0, 0, 0, .8);
                             padding-left: 20px;
                             box-sizing: border-box;
                         }
                     }
                 }
             }
        }
        .@{classNames}_content_none{
            width: 100%;
            height: 500px;
        }
    }
    .content-item-right{
        display: flex;
        flex-direction: column;
        .@{classNames}_content_item_class{
            margin-bottom: 10px;
        }
    }
</style>
